module.exports = __webpack_public_path__ + "img/alerta_campana.e82be051.svg";